var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContactFormFailed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 150 150"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "contact_form_failed_svg__a",
  x1: -1.357,
  y1: 9.817,
  x2: 132.103,
  y2: 126.428,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#003ce1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.137,
  stopColor: "#492cd0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.302,
  stopColor: "#920cbd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.452,
  stopColor: "#ca01ad"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.582,
  stopColor: "#f500a2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.686,
  stopColor: "#fd029a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.751,
  stopColor: "#fd0397"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d80135"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M73.244 139.429c-35.526 0-64.429-28.903-64.429-64.429s28.903-64.429 64.429-64.429 64.43 28.903 64.43 64.429-28.904 64.429-64.43 64.429Zm0-126.858c-34.423 0-62.429 28.006-62.429 62.429s28.006 62.429 62.429 62.429 62.43-28.006 62.43-62.429-28.006-62.429-62.43-62.429ZM50.452 111.04 37.204 97.793 59.997 75 37.204 52.208 50.452 38.96l22.792 22.792L96.037 38.96l13.248 13.248L86.492 75l22.793 22.793-13.248 13.247-22.793-22.792-22.792 22.792Zm22.792-25.62 22.793 22.792 10.42-10.419L83.664 75l22.793-22.792-10.42-10.42-22.793 22.793-22.792-22.793-10.42 10.42L62.825 75 40.032 97.793l10.42 10.419L73.244 85.42Zm-6.607-13.948L52.005 56.84l-.707.707L65.93 72.18l.707-.707Zm59.743 18.91A55.386 55.386 0 0 0 128.548 75c0-12.455-4.042-24.215-11.69-34.008a.5.5 0 0 0-.789.615c7.51 9.616 11.479 21.164 11.479 33.393 0 5.135-.716 10.217-2.13 15.104a.5.5 0 0 0 .962.278Zm-52.636 39.42a.5.5 0 0 0-.5-.5c-29.942 0-54.303-24.36-54.303-54.302s24.36-54.303 54.303-54.303a54.203 54.203 0 0 1 36.215 13.84.5.5 0 0 0 .668-.745 55.209 55.209 0 0 0-36.883-14.095C42.75 19.697 17.941 44.506 17.941 75s24.809 55.303 55.303 55.303a.5.5 0 0 0 .5-.5Zm34.443-11.935c8.776-7.162 15.067-16.666 18.193-27.485a.5.5 0 0 0-.961-.278c-3.07 10.624-9.247 19.956-17.864 26.988a.501.501 0 0 0 .632.775Z",
  style: {
    fill: "url(#contact_form_failed_svg__a)"
  }
}));
export default SvgContactFormFailed;